import { useQuery } from "react-query-legacy";
import { BillingEngineService } from "services";

function useImportedCarriers() {
  return useQuery(["imported-carriers"], BillingEngineService.getCarriers);
}

export default useImportedCarriers;
